module.exports = __webpack_public_path__ + "img/account-part.a47689e6.svg";